export default __webpack_public_path__ + "static/media/BRASAO_SECTI_PNG-02.2c743c7c.png";